import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faRoute } from "@fortawesome/free-solid-svg-icons"
import { CourierEntity } from "../../../Objects/Courier/CourierEntity"
import { Status } from "./Status"
import { useTranslation } from "react-i18next"

interface Props {
  courier: CourierEntity
  onUnlink: (id: string) => void
  onViewActiveRoute: (courier: CourierEntity) => void
}

export function CourierCard({ courier, onUnlink, onViewActiveRoute }: Props) {
  const { t } = useTranslation("frontend")
  return (
    <div
      key={courier.id}
      className="bg-white border-2 border-slate-200 rounded-xl shadow-sm hover:shadow-md transition p-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-full bg-orange-100 text-orange-600 flex items-center justify-center font-semibold text-lg">
          {courier.personEntity.name?.charAt(0).toUpperCase()}
        </div>

        <div>
          <div className="font-semibold text-slate-800 text-lg">{courier.personEntity.name}</div>

          <div className="text-sm text-slate-500">{courier.personEntity.email}</div>

          <div className="text-xs text-slate-400">{courier.personEntity.phone}</div>

          {courier.lastSeenDatetime && (
            <div className="text-xs text-slate-500 font-bold mt-1">
              {t("delivery_common.last_activity")} {new Date(courier.lastSeenDatetime).toLocaleDateTimeOrDash()}
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <Status status={courier.status} />

        <button
          onClick={() => onViewActiveRoute(courier)}
          className="flex items-center gap-1.5 text-xs font-medium px-3 py-2 rounded-lg bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-sm transition hover:opacity-90"
          data-interaction-description-key="interactionDescriptions:pages.delivery.components.courierCard.button.onViewActiveRoute"
        >
          <FontAwesomeIcon icon={faRoute} />
          {t("courier_partners.view_active_route")}
        </button>

        <button
          onClick={() => onUnlink(courier.id)}
          className="text-xs font-medium px-3 py-2 ring-2 ring-red-300 rounded-lg border border-red-200 text-red-600 hover:bg-red-50 transition"
          data-interaction-description-key="interactionDescriptions:pages.delivery.components.courierCard.button.onUnlinkCourierId"
        >
          {t("courier_partners.unlink_title")}
        </button>
      </div>
    </div>
  )
}
